module.exports = __webpack_public_path__ + "img/color-wheel.0fc36b2a.png";